<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project?batchId=' +  $route.query.batchId }">项目奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>确认授奖</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form :model="addForm" v-loading="loading" :rules="ruleAddForm" ref="addForm" label-width="180px" class="demo-ruleForm-zdy demo-ruleForms" size="small" >
        <el-form-item label="是否授奖" prop="isConfirm" >
          <el-radio-group v-model="addForm.isConfirm">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="'完成单位' + '(最多' + numUnit +'家)'" required v-if="addForm.isConfirm == 1">
          <div v-for="(item, index) in addForm.completeUnit" :key="index" style="width: 100%; ">
            <el-row >
              <el-col :span="14">
                <el-form-item style="width: 100%" :prop="'completeUnit.' + index" :rules="{ required: true, message: '请输入完成单位', trigger: 'blur' }" >
                  <el-input maxlength="50" show-word-limit placeholder="请输入完成单位" v-model.trim="addForm.completeUnit[index]"></el-input>
              </el-form-item>
              </el-col>
              <el-col :span="8">
                <div style="margin-left: 10px;" v-if="index > 0">
                  <el-button type="danger" size="small" @click="del('completeUnit', index)">删除</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div >
            <el-button type="primary" icon="el-icon-plus" size="small" @click="add('completeUnit')">添加完成单位</el-button>
          </div>
        </el-form-item>
        <!--  -->
        <el-form-item :label="'完成人信息' + '(最多' + numPeople +'人)'" required v-if="addForm.isConfirm == 1">
          <el-form :model="pepForm" ref="pepForm" size="small">
            <div v-for="(item, index) in pepForm.list" :key="index" style="width: 100%; overflow: hidden; background: #F7F8FA; padding: 10px 15px; box-sizing: border-box; border-radius: 4px; margin-bottom: 10px; position: relative;">
              <el-row :gutter="20">
                <el-col :span="5">
                  <el-form-item label="姓名" :prop="'list.' + index + '.name'" :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }">
                    <el-input size="small" maxlength="50" show-word-limit v-model.trim="item.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="联系方式" :prop="'list.' + index + '.phone'" :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                    <el-input maxlength="11" show-word-limit v-model.trim="item.phone" placeholder="请输入联系方式"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邮箱" :prop="'list.' + index + '.email'" :rules="[{ required: true, message: '请输入邮箱地址', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
                    <el-input maxlength="30" show-word-limit v-model.trim="item.email" placeholder="请输入邮箱"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证" :prop="'list.' + index + '.card'" :rules="[{ required: true, message: '请输入身份证', trigger: 'blur' },
            { pattern: /^[1-9]\d{5}(18|19|([20]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式错误', trigger: ['blur', 'change'] }]">
                      <el-input maxlength="18" show-word-limit v-model.trim="item.card" placeholder="请输入身份证"></el-input>
                    </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="5">
                  <el-form-item label="工作单位" :prop="'list.' + index + '.unit'" :rules="{ required: true, message: '请输入工作单位', trigger: 'blur' }">
                    <el-input size="small" maxlength="50" show-word-limit v-model.trim="item.unit" placeholder="请输入工作单位"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="职务" :prop="'list.' + index + '.job'" :rules="{ required: true, message: '请输入职务', trigger: 'blur' }">
                    <el-input size="small" maxlength="30" show-word-limit v-model.trim="item.job" placeholder="请输入职务"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="职称" :prop="'list.' + index + '.named'" :rules="{ required: true, message: '请输入职称', trigger: 'blur' }">
                    <el-input size="small" maxlength="30" show-word-limit v-model.trim="item.named" placeholder="请输入职称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="毕业院校" :prop="'list.' + index + '.graduate'" :rules="{ required: true, message: '请输入毕业院校', trigger: 'blur' }">
                    <el-input size="small" maxlength="50" show-word-limit v-model.trim="item.graduate" placeholder="请输入毕业院校"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button style="position: absolute; right: 5px; top: 5px;" type="danger" size="mini" @click="del('list', index)" v-if="index > 0">删除</el-button>
              <div style="position: absolute; top: 0px; left: 0px; width: 18px; height: 18px; line-height: 20px; text-align: center; border: 1px solid #000; border-radius: 50%;">{{ index + 1 }}</div>
            </div>
            <div >
              <el-button icon="el-icon-plus" type="primary" size="small" @click="add('list')">添加完成人</el-button>
            </div>
            <!-- <el-row style="margin-bottom: 10px;">
              <el-col :span="5">完成人姓名</el-col>
              <el-col :span="5" style="padding-left: 10px;">完成人联系方式</el-col>
              <el-col :span="6" style="padding-left: 10px;">完成人邮箱</el-col>
              <el-col :span="8" style="padding-left: 10px;">完成人身份证</el-col>
            </el-row> -->
            <!-- <el-row >
              <el-col :span="5">
                <div v-for="(item, index) in addForm.completePeople" :key="index" style="width: 100%; ">
                  <el-form-item style="width: 100%;" :prop="'completePeople.' + index" :rules="{ required: true, message: '请输入完成人姓名', trigger: 'blur' }" >
                    <el-input maxlength="20" show-word-limit placeholder="请输入完成人姓名" v-model.trim="addForm.completePeople[index]" ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="5" >
                <div v-for="(item, index) in addForm.completePhones" :key="index">
                  <div style="display: flex; padding-left: 10px; box-sizing: border-box; ">
                    <el-form-item style="width: 100%;" :prop="'completePhones.' + index" :rules="[{ required: true, message: '请输入完成人联系方式', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                      <el-input maxlength="11" show-word-limit v-model.trim="addForm.completePhones[index]" placeholder="请输入完成人联系方式"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="6" >
                <div v-for="(item, index) in addForm.emails" :key="index">
                  <div style="display: flex; padding-left: 10px; box-sizing: border-box; ">
                    <el-form-item style="width: 100%;" :prop="'emails.' + index" :rules="[{ required: true, message: '请输入邮箱地址', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
                      <el-input maxlength="30" show-word-limit v-model.trim="addForm.emails[index]" placeholder="请输入完成人邮箱"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="8" >
                <div v-for="(item, index) in addForm.identityCards" :key="index">
                  <div style="display: flex; padding-left: 10px; box-sizing: border-box; ">
                    <el-form-item style="width: 100%;" :prop="'identityCards.' + index" :rules="[{ required: true, message: '请输入完成人身份证', trigger: 'blur' },
            { pattern: /^[1-9]\d{5}(18|19|([20]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式错误', trigger: ['blur', 'change'] }]">
                      <el-input maxlength="18" show-word-limit v-model.trim="addForm.identityCards[index]" placeholder="请输入完成人身份证"></el-input>
                    </el-form-item>
                    <div style="width: 80px; margin-left: 10px;">
                      <el-button type="danger" size="small" @click="del('completePeople', index)" v-if="index > 0">删除</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row> -->
            <!-- <div >
              <el-button type="primary" icon="el-icon-plus" size="small" @click="add('completePeople')">添加完成人</el-button>
            </div> -->
          </el-form>
        </el-form-item>
        <el-form-item label="放弃授奖证明(盖章扫描件 100MB)" prop="rejectAwardFileUrl" v-if="addForm.isConfirm == 2" key="rejectAwardFileUrl">
          <el-checkbox-group v-model="addForm.rejectAwardFileUrl" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :size="100" @UploadFileFun="UploadFileFun($event, 'rejectAwardFileUrl')" :callbackShow="addForm.declarationFiles"></My-Upload-Filebutton>
        </el-form-item>
        <!-- 研究报告摘要 -->
        <el-form-item label="研究报告摘要" v-if="addForm.isConfirm == 1">
          <el-row>
            <el-col :span="14">
              <el-input
                readonly
                disabled
                :autosize="{ minRows: 2, maxRows: 4}"
                maxlength="200"
                show-word-limit
                type="textarea"
                size="mini"
                aria-placeholder="研究报告摘要"
                v-model="isResearBg" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="是否公开研究报告摘要" prop="isOpen" v-if="addForm.isConfirm == 1">
          <el-radio-group v-model="addForm.isOpen">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin: 80px 0 20px 180px; " v-if="status == 1">
          <el-button type="primary" @click="submit" :loading="addForm.loading">提 交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
import { awardconfirm, getAwardconfirm, getProjectAwardBatchList, getStProjectAward } from '@/api/admin'

export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      isResearBg: '', // 研究报告
      status: '',
      id: '',
      flag: false,
      numUnit: '',
      numPeople: '',
      pepForm: {
        list: [{ name: '', phone: '', email: '', card: '', unit: '', job: '', named: '', graduate: '' }]
      },
      addForm: {
        loading: false,
        isConfirm: '1', // 是否受奖
        isOpen: '', // 是否公开
        completeUnit: [''], // 单位
        completePeople: [], // 姓名
        completePhones: [], // 手机号
        emails: [], // 邮箱
        identityCards: [], // 身份证
        peopleUnit: [], // 单位
        peoplePosition: [], // 职位
        peopleTitleName: [], // 职位
        peopleSchool: [], // 职位
        rejectAwardFileUrl: '' // 是否公开研究报告摘要
      },
      loading: false,
      ruleAddForm: {
        isConfirm: [{ required: true, message: '请选择是否授奖', trigger: 'change' }],
        isOpen: [{ required: true, message: '请选择是否公开研究报告', trigger: 'change' }],
        rejectAwardFileUrl: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  created() {
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/project/batch' })
      return false
    }
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/project/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
    if (!this.$route.query.awardsLv) {
      this.$router.replace({ path: '/project', batchId: this.$route.query.batchId })
    } else {
      if (this.$route.query.awardsLv == 1) {
        this.numUnit = 10
        this.numPeople = 15
      } else if (this.$route.query.awardsLv == 2) {
        this.numUnit = 7
        this.numPeople = 10
      } else if (this.$route.query.awardsLv == 3) {
        this.numUnit = 5
        this.numPeople = 8
      } else {
        this.numUnit = 15
        this.numPeople = 25
      }
      getAwardconfirm({ id: this.$route.query.id }).then(res => {
        if (res.code === '000') {
          const data = res.result
          if (!data) return false
          if (data.completeUnit) {
            this.flag = true
          }
          this.id = data.id
          this.addForm.isOpen = data.isOpenGen
          this.addForm.completeUnit = data.completeUnit.split(',') // 单位
          if (this.addForm.isConfirm == 1) {
            const completePeople = data.completePeople.split(',')
            const completePhones = data.completePhones.split(',')
            const emails = data.emails.split(',')
            const identityCards = data.identityCards.split(',')
            const peopleUnit = data.peopleUnit.split(',')
            const peoplePosition = data.peoplePosition.split(',')
            const peopleTitleName = data.peopleTitleName.split(',')
            const peopleSchool = data.peopleSchool.split(',')
            this.pepForm.list = completePeople.map((n, index) => ({
              name: n,
              phone: completePhones[index] || '',
              email: emails[index] || '',
              card: identityCards[index] || '',
              unit: peopleUnit[index] || '',
              job: peoplePosition[index] || '',
              named: peopleTitleName[index] || '',
              graduate: peopleSchool[index] || ''
            }))
          }
          // this.addForm.completePeople = data.completePeople.split(',') // 姓名
          // this.addForm.completePhones = data.completePhones ? data.completePhones.split(',') : [] // 手机号
          // this.addForm.identityCards = data.identityCards ? data.identityCards.split(',') : [] // 身份证
          // this.addForm.emails = data.emails ? data.emails.split(',') : [] // 邮箱
          // this.addForm.emails = data.emails ? data.emails.split(',') : [] // 工作单位
          // this.addForm.emails = data.emails ? data.emails.split(',') : [] // 职务
          // this.addForm.emails = data.emails ? data.emails.split(',') : [] // 职称
          // this.addForm.emails = data.emails ? data.emails.split(',') : [] // 毕业院校

          const alignedArrays = this.alignArrays(this.addForm.completePeople, this.addForm.completePhones, this.addForm.emails, this.addForm.identityCards)
          this.addForm.completePeople = alignedArrays[0]
          this.addForm.completePhones = alignedArrays[1]
          this.addForm.emails = alignedArrays[2]
          this.addForm.identityCards = alignedArrays[3]
          // if (this.addForm.completePeople.length > this.addForm.emails.length) {
          //   this.addForm.completePeople.forEach(item => {
          //     this.addForm.completePhones.push('')
          //     this.addForm.identityCards.push('')
          //     this.addForm.emails.push('')
          //   })
          // }
        }
      })
    }
    this.loading = true
    getStProjectAward({ id: this.$route.query.id }).then(res => {
      this.loading = false
      if (res.code == '000') {
        this.isResearBg = res.result.declareVo.isResearBg
      }
    })
  },
  methods: {
    alignArrays (arr1, arr2, arr3, arr4) {
      const maxLength = Math.max(arr1.length, arr2.length, arr3.length, arr4.length)
      if (arr1.length < maxLength) {
        arr1.push(...new Array(maxLength - arr1.length).fill(''))
      }
      if (arr2.length < maxLength) {
        arr2.push(...new Array(maxLength - arr2.length).fill(''))
      }
      if (arr3.length < maxLength) {
        arr3.push(...new Array(maxLength - arr3.length).fill(''))
      }
      if (arr4.length < maxLength) {
        arr4.push(...new Array(maxLength - arr4.length).fill(''))
      }
      return [arr1, arr2, arr3, arr4]
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    add (type) {
      switch (type) {
        case 'completeUnit':
          if (this.addForm[type].length > this.numUnit - 1) return this.$message.warning(`最多添加${this.numUnit}家完成单位`)
          this.addForm[type].push('')
          break
        case 'list':
          if (this.pepForm.list.length > this.numPeople - 1) return this.$message.warning(`最多添加${this.numPeople}个完成人`)
          this.pepForm.list.push({ name: '', phone: '', email: '', card: '', unit: '', job: '', named: '', graduate: '' })
          break
      }
    },
    del (type, index) {
      if (type == 'completePeople') {
        this.addForm.completePeople.splice(index, 1)
      } else if (type == 'list') {
        this.pepForm.list.splice(index, 1)
      }
      // this.addForm[type].splice(index, 1)
      // if (type == 'completePeople') {
      //   this.addForm.completePhones.splice(index, 1)
      //   this.addForm.identityCards.splice(index, 1)
      //   this.addForm.emails.splice(index, 1)
      // }
      // this.addForm[type].splice(index, 1)
    },
    async submit () {
      const parentValid = await this.validateForm('addForm')
      if (!parentValid) return false
      if (this.addForm.isConfirm == 1) {
        const childValid = await this.validateForm('pepForm')
        if (!childValid) return false
      }
      this.$confirm('是否确定提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.addForm.isConfirm == 1) {
          this.pepForm.list.forEach(item => {
            this.addForm.completePeople.push(item.name)
            this.addForm.completePhones.push(item.phone)
            this.addForm.emails.push(item.email)
            this.addForm.identityCards.push(item.card)
            this.addForm.peopleUnit.push(item.unit)
            this.addForm.peoplePosition.push(item.job)
            this.addForm.peopleTitleName.push(item.named)
            this.addForm.peopleSchool.push(item.graduate)
          })
        }
        const params = {
          projectAwardId: this.$route.query.id,
          isConfirm: this.addForm.isConfirm,
          isOpenGen: this.addForm.isConfirm == 1 ? this.addForm.isOpen : '',
          completeUnit: this.addForm.isConfirm == 1 ? this.addForm.completeUnit.join(',') : '',
          completePeople: this.addForm.isConfirm == 1 ? this.addForm.completePeople.join(',') : '',
          identityCards: this.addForm.isConfirm == 1 ? this.addForm.identityCards.join(',') : '',
          completePhones: this.addForm.isConfirm == 1 ? this.addForm.completePhones.join(',') : '',
          emails: this.addForm.isConfirm == 1 ? this.addForm.emails.join(',') : '',
          peopleUnit: this.addForm.isConfirm == 1 ? this.addForm.peopleUnit.join(',') : '',
          peoplePosition: this.addForm.isConfirm == 1 ? this.addForm.peoplePosition.join(',') : '',
          peopleTitleName: this.addForm.isConfirm == 1 ? this.addForm.peopleTitleName.join(',') : '',
          peopleSchool: this.addForm.isConfirm == 1 ? this.addForm.peopleSchool.join(',') : '',
          rejectAwardFileUrl: this.addForm.isConfirm == 1 ? '' : this.addForm.rejectAwardFileUrl
        }
        if (this.flag) {
          params.id = this.id
        }
        this.addForm.loading = true
        awardconfirm(params).then(res => {
          this.addForm.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.$router.replace({ path: '/project', query: { batchId: this.$route.query.batchId } })
            }, 500)
          }
        })
      })
      // console.log(222)
      // console.log(this.addForm.isConfirm)
      // if (this.addForm.completeUnit.length > this.numUnit) return this.$message.warning(`最多添加${this.numUnit}家完成单位`)
      // if (this.pepForm.list.length > this.numPeople) return this.$message.warning(`最多添加${this.numPeople}个完成人信息`)
      // this.$refs.addForm.validate(valid => {
      //   if (!valid) return false
      //   if (this.addForm.isConfirm == 1) {
      //     this.$refs.pepForm.validate(valids => {
      //       if (!valid) return false
      //     })
      //   }
      //   this.$confirm('是否确定提交?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     const params = {
      //       projectAwardId: this.$route.query.id,
      //       isConfirm: this.addForm.isConfirm,
      //       isOpenGen: this.addForm.isConfirm == 1 ? this.addForm.isOpen : '',
      //       completeUnit: this.addForm.isConfirm == 1 ? this.addForm.completeUnit.join(',') : '',
      //       completePeople: this.addForm.isConfirm == 1 ? this.addForm.completePeople.join(',') : '',
      //       identityCards: this.addForm.isConfirm == 1 ? this.addForm.identityCards.join(',') : '',
      //       completePhones: this.addForm.isConfirm == 1 ? this.addForm.completePhones.join(',') : '',
      //       emails: this.addForm.isConfirm == 1 ? this.addForm.emails.join(',') : '',
      //       rejectAwardFileUrl: this.addForm.isConfirm == 1 ? '' : this.addForm.rejectAwardFileUrl
      //     }
      //     if (this.flag) {
      //       params.id = this.id
      //     }
      //     this.addForm.loading = true
      //     awardconfirm(params).then(res => {
      //       this.addForm.loading = false
      //       if (res.code === '000') {
      //         this.$message.success('操作成功')
      //         setTimeout(() => {
      //           this.$router.replace({ path: '/project', query: { batchId: this.$route.query.batchId } })
      //         }, 500)
      //       }
      //     })
      //   })
      // })
    },
    validateForm(formRef) {
      return new Promise((resolve) => {
        this.$refs[formRef].validate((valid) => {
          resolve(valid)
        })
      })
    }
  }
}
</script>

<style lang="less">
.demo-ruleForm-zdy {
  .el-form-item__content {
    line-height: 32px;
  }
  .el-form-item__label {
    line-height: 32px;
  }
}

</style>
